// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalInfo_container__3ThOg","row":"PersonalInfo_row__zZwaG","attrCell":"PersonalInfo_attrCell__1m2je","valueCell":"PersonalInfo_valueCell__13Jnw"};